/**
 * Prose helpers for the sentences the admin builds out of lists — the Publish
 * button's "set a campaign ID, set a round, and add at least one fixture", the
 * cancel action's list of statuses.
 *
 * Shared because `contests/readiness.ts` and `contest-detail-page.tsx` both
 * assemble such a sentence, and two copies of an Oxford comma are two chances
 * for one surface to punctuate differently from the other.
 */

/** `["a"]` → `a`; `["a","b"]` → `a and b`; `["a","b","c"]` → `a, b, and c`. */
export const formatList = (items: readonly string[]): string => {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0]!;
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
};

/** Capitalises the first character and leaves the rest alone. */
export const sentenceCase = (value: string): string =>
  value.length === 0 ? value : `${value[0]!.toUpperCase()}${value.slice(1)}`;
